module.exports = __webpack_public_path__ + "static/media/outside-wall.a48a180e.png";